import { render } from "./dealer_clerk.vue?vue&type=template&id=3fc91c8c"
import script from "./dealer_clerk.vue?vue&type=script&lang=js"
export * from "./dealer_clerk.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__